import RightPanelCard from 'components/CommonComponents/RightPanelCard'
import { format } from 'date-fns';
import React, { useContext, useEffect, useState } from 'react'
import DatePicker from 'react-datepicker';
import { Button, Card, CardBody, CardFooter, CardHeader, Col, FormGroup, Input, Label, Row, UncontrolledTooltip } from 'reactstrap';
import Select from "react-select";
import { SELECT_CUSTOM_STYLES } from 'constants/CommonConstants';
import CommonTable from 'components/CommonComponents/ReactTable/Table';
import { DEFAULT_RECORDS_PER_PAGE, ALL_SESSION_TYPE_OPTIONS, SESSION_STATUS_OPTIONS } from 'components/constant';
import { useDispatch, useSelector } from 'react-redux';
import { getCourseEnrollmentList } from 'action/batch';
import { courseEnrollmentList } from 'constants/batch';
import { NotificationContext } from 'components/CommonComponents/NotificationProvider';
import { addAttendance, updateAttendance, getSessionByID } from 'action/attendanceModule';
import { getBatchScheduledDates } from 'action/attendanceModule';
import { formatTime24Hour, parseTimeStringToDate } from 'components/CommonComponents/CommonFunctions';
import CustomTimePicker from "components/CommonComponents/CustomTimePicker";

const initialFormData = {
    batchId: {
        value: "",
        error: "",
        isChanged: false,
    },
    sessionDate: {
        value: "",
        error: "",
        isChanged: false,
    },
    sessionStartTime: {
        value: "",
        error: "",
        isChanged: false,
    },
    sessionEndTime: {
        value: "",
        error: "",
        isChanged: false,
    },
    sessionType: {
        value: { value: "OFFLINE", label: "Offline" },
        error: "",
        isChanged: false,
    },
    sessionStatus: {
        value: "",
        error: "",
        isChanged: false,
    },
};

function ManageOfflineAttendance(props) {
    const dispatch = useDispatch();
    const courseEnrollmentData = useSelector(
        (state) => state.batch.courseEnrollmentList,
    );
    const { notify } = useContext(NotificationContext);

    const [formData, setFormData] = useState(initialFormData);
    const [alternative, setAlternative] = useState({
        isLoading: true,
        showLoaderOnClick: false,
        showLoaderOnSearch: false,
        error: "",
        noRecords: false,
    });

    const [selectedRows, setSelectedRows] = useState([]);
    const [pageNum, setPageNum] = useState(1);
    const [searchState, setSearchState] = useState({
        searchName: "",
        searchEmail: "",
        searchMobile: "",
        filterParams: [],
    });
    const [trainees, setTrainees] = useState([]);
    const [attendanceMap, setAttendanceMap] = useState({});
    const [traineesRecords, setTraineesRecords] = useState({ totalRecords: null, totalFilteredRecords: null });
    const [batchScheduledDates, setBatchScheduledDates] = useState([]);

    const filterKey = JSON.stringify(searchState.filterParams || []);

    // used to show batch available session dates
    const availableSessionDates = batchScheduledDates
        ?.filter(item => !item.attendance_added)
        ?.map(item => item.date) || [];

    // Set the calendar to open on the first available session date
    // If no dates are available, open on the current date
    const firstAvailableDate = availableSessionDates?.length
        ? new Date(availableSessionDates[0])
        : new Date();

    const minAvailableDate = availableSessionDates?.length
        ? new Date(availableSessionDates[0])
        : null;

    // const maxAvailableDate = availableSessionDates?.length
    //     ? new Date(availableSessionDates[availableSessionDates.length - 1])
    //     : null;

    const sessionTypeOptions = props?.batch?.contentDeliveryMode === "BOTH"
        ? ALL_SESSION_TYPE_OPTIONS
        : ALL_SESSION_TYPE_OPTIONS.filter(opt =>
            opt.value === (props?.batch?.contentDeliveryMode || "OFFLINE")
        );

    useEffect(() => {
        if (!props.openAttendaceModel || !props?.batch?.id) return;
        if (props?.mode === "Add") {
            setTrainees([]);
            setAttendanceMap({});
            setSelectedRows([]);
            setTraineesRecords({
                totalRecords: null,
                totalFilteredRecords: null
            });
            setPageNum(1);
            getBatchDates();
        }
    }, [props.openAttendaceModel, props?.batch?.id]);

    useEffect(() => {
        if (!props.openAttendaceModel || !props?.batch?.id) return;
        if (props?.mode === "Add") {
            setAlternative((prev) => ({
                ...prev,
                isLoading: true,
            }));

            getCourseEnrollmentList(
                props.batch.id,
                dispatch,
                pageNum,
                searchState.filterParams?.length ? searchState.filterParams : []
            );

            return () => {
                dispatch({ type: courseEnrollmentList, payload: {} });
            };
        }
    }, [props.openAttendaceModel, props?.batch?.id, pageNum, filterKey]);

    useEffect(() => {
        if (props?.mode === "Add" && courseEnrollmentData?.code === 200) {
            const traineeList = (courseEnrollmentData?.data?.trainees || []).map(
                (trainee) => ({
                    id: trainee.traineeID,
                    traineeName: trainee.fullName || trainee.traineeName || "-",
                    email: trainee.email || trainee.traineeEmail || "-",
                    attendance:
                        attendanceMap[trainee.traineeID] || "Present",
                })
            );

            // Create attendance map for all trainees
            const initialAttendanceMap = (courseEnrollmentData?.data?.trainees || []).reduce(
                (acc, trainee) => {
                    acc[trainee.traineeID] = "Present";
                    return acc;
                },
                {}
            );

            setTrainees(traineeList);
            setAttendanceMap((prev) => ({
                ...initialAttendanceMap,
                ...prev, // preserve previously marked Present/Absent
            }));

            setFormData((prev) => ({
                ...prev,
                batchId: {
                    ...prev.batchId,
                    value: props.batch.id,
                },
                sessionStatus: {
                    ...prev.batchId,
                    value: { value: "INPROGRESS", label: "Ongoing" },
                },
                sessionType: {
                    ...prev.sessionType,
                    value: props?.batch?.contentDeliveryMode === "BOTH"
                        ? null
                        : ALL_SESSION_TYPE_OPTIONS.find(opt => opt.value === (props?.batch?.contentDeliveryMode || "OFFLINE")) || null
                },
                sessionStartTime: {
                    ...prev.sessionStartTime,
                    value: props?.batchDates?.batchStartTime ? formatTime24Hour(props?.batchDates?.batchStartTime) : ""
                },
                sessionEndTime: {
                    ...prev.sessionEndTime,
                    value: props?.batchDates?.batchEndTime ? formatTime24Hour(props?.batchDates?.batchEndTime) : ""
                },
            }));

            setAlternative({
                isLoading: false,
                error: "",
                noRecords: courseEnrollmentData?.data?.trainees?.length === 0,
                showLoaderOnClick: false,
                showLoaderOnSearch: false,
            });
        } else if (courseEnrollmentData?.code || courseEnrollmentData?.message) {
            setTrainees([]);

            setAlternative({
                isLoading: false,
                error:
                    courseEnrollmentData?.message ||
                    "Failed to load enrolled students! Please try again.",
                noRecords: false,
                showLoaderOnClick: false,
                showLoaderOnSearch: false,
            });
        }
    }, [props.openAttendaceModel, courseEnrollmentData]);

    useEffect(() => {
        if (!props.openAttendaceModel) return
        if (props?.mode === "Edit" || props?.mode === "View") {
            setAlternative((prev) => ({ ...prev, isLoading: true, }));
            getSessionData();
        }
    }, [props.openAttendaceModel, pageNum, filterKey]);

    const getBatchDates = async () => {
        try {
            const res = await getBatchScheduledDates(props.batch.id);
            if (res?.code === 200) {
                setBatchScheduledDates(res?.data?.dates)
            } else {
                notify("success", res?.message || "Failed to get batch scheduled dates");

            }
        } catch (error) {
            notify("success", error?.message || "Failed to get batch scheduled dates");
        }
    }

    const getSessionData = async () => {
        const res = await getSessionByID(props?.session?.id, pageNum, searchState.filterParams?.length ? searchState.filterParams : []);
        if (res?.code === 200) {
            const traineeList = (res?.data?.trainees || []).map(
                (trainee) => ({
                    id: trainee.traineeId,
                    traineeName: trainee.fullName || trainee.traineeName || "-",
                    email: trainee.email || trainee.traineeEmail || "-",
                    attendance: trainee.attendanceStatus === "ABSENT"
                        ? "Absent"
                        : "Present"
                })
            );

            const initialAttendanceMap = (res?.data?.trainees || []).reduce(
                (acc, trainee) => {
                    acc[trainee.traineeId] =
                        trainee.attendanceStatus === "ABSENT"
                            ? "Absent"
                            : "Present";

                    return acc;
                },
                {}
            );

            setTraineesRecords({ totalRecords: res?.data?.totalRecords, totalFilteredRecords: res?.data?.totalFilteredRecords })

            setAttendanceMap(initialAttendanceMap);

            setTrainees(traineeList);

            setFormData((prev) => ({
                ...prev,
                batchId: {
                    ...prev.batchId,
                    value: props.batch.id,
                },
                sessionDate: {
                    ...prev.sessionDate,
                    value: res?.data?.sessionDate
                        ? new Date(res.data.sessionDate)
                        : null,
                },
                sessionStartTime: {
                    ...prev.sessionStartTime,
                    value:
                        props?.mode === "Edit"
                            ? formatTime24Hour(res?.data?.sessionStartTime)
                            : res?.data?.sessionStartTime,
                },
                sessionEndTime: {
                    ...prev.sessionEndTime,
                    value:
                        props?.mode === "Edit"
                            ? formatTime24Hour(res?.data?.sessionEndTime)
                            : res?.data?.sessionEndTime,
                },
                sessionType: {
                    ...prev.sessionType,
                    value:
                        ALL_SESSION_TYPE_OPTIONS.find(
                            item => item.value === res.data.sessionType
                        ) || null,
                },
                sessionStatus: {
                    ...prev.sessionStatus,
                    value:
                        SESSION_STATUS_OPTIONS.find(
                            item => item.value === res.data.sessionStatus
                        ) || null,
                },
            }));

            setAlternative({
                isLoading: false,
                error: "",
                noRecords: res?.data?.trainees?.length === 0,
                showLoaderOnClick: false,
                showLoaderOnSearch: false,
            });
        } else if (res?.code || res?.message) {
            setTrainees([]);

            setAlternative({
                isLoading: false,
                error:
                    res?.message ||
                    "Failed to load enrolled students! Please try again.",
                noRecords: false,
                showLoaderOnClick: false,
                showLoaderOnSearch: false,
            });
        }
    };

    const traineeTableData = trainees.map((trainee, index) => ({
        ...trainee,
        srNo:
            ((pageNum - 1) *
                (courseEnrollmentData?.data?.noOfRecordsPerPage ||
                    DEFAULT_RECORDS_PER_PAGE)) +
            index +
            1,
    }));

    const allSelected =
        traineeTableData?.length > 0 &&
        traineeTableData?.every((t) => selectedRows.includes(t.id));

    const addMinutes = (time, minutes) => {
        if (!time) return "";

        const [hour, minute] = time.split(":").map(Number);

        const date = new Date();
        date.setHours(hour, minute + minutes, 0, 0);

        return date.toTimeString().slice(0, 5);
    };

    const toggleRowSelection = (id) => {
        setSelectedRows((prev) =>
            prev.includes(id)
                ? prev.filter((rowId) => rowId !== id)
                : [...prev, id]
        );

    };

    const toggleSelectAll = () => {
        if (allSelected) {
            setSelectedRows((prev) =>
                prev.filter(
                    (id) => !traineeTableData?.some((t) => t.id === id)
                )
            );
        } else {
            const ids = traineeTableData?.map((t) => t.id);

            setSelectedRows((prev) => [
                ...new Set([...prev, ...ids]),
            ]);
        }
    };

    const columns =
        props.mode === "View"
            ? [
                {
                    Header: "Sr. No.",
                    accessor: "srNo",
                    centerAlign: true,
                    minWidth: 100,
                    maxWidth: 160,
                },
                {
                    Header: "Name",
                    accessor: "traineeName",
                    minWidth: 250,
                    Cell: ({ value }) => (
                        <span className="text-wrapper">{value || "-"}</span>
                    ),
                },
                {
                    Header: "Email",
                    accessor: "email",
                    minWidth: 180,
                    Cell: ({ value }) => (
                        <span className="text-wrapper">{value || "-"}</span>
                    ),
                },
                {
                    Header: "Attendance",
                    accessor: "attendance",
                    minWidth: 120,
                    centerAlign: true,
                    Cell: ({ value }) => (
                        <span
                            className={`attendance-badge ${value === "Present"
                                ? "present"
                                : "absent"
                                }`}
                        >
                            <i
                                className={`fa ${value === "Present"
                                    ? "fa-check-circle"
                                    : "fa-times-circle"
                                    }`}
                            />
                            {value}
                        </span>
                    ),
                },
            ] : [
                {
                    Header: (
                        <Input
                            type="checkbox"
                            checked={allSelected}
                            onChange={toggleSelectAll}
                            className="attendance-checkbox"
                        />
                    ),
                    accessor: "select",
                    disableSortBy: true,
                    minWidth: 50,
                    maxWidth: 50,
                    Cell: ({ row }) => (
                        <Input
                            type="checkbox"
                            checked={selectedRows.includes(row.original.id)}
                            onChange={() => toggleRowSelection(row.original.id)}
                            className="attendance-checkbox"
                        />
                    ),
                },
                {
                    Header: "Sr. No.",
                    accessor: "srNo",
                    centerAlign: true,
                    minWidth: 20,
                    maxWidth: 50,
                },
                {
                    Header: "Name",
                    accessor: "traineeName",
                    minWidth: 160,
                    maxWidth: 250,
                    Cell: ({ value }) => <span className="text-wrapper">{value || "-"}</span>,
                },
                {
                    Header: "Email",
                    accessor: "email",
                    minWidth: 200,
                    maxWidth: 250,
                    Cell: ({ value }) => <span className="text-wrapper">{value || "-"}</span>,
                },
                {
                    Header: "Mark Attendance",
                    disableSortBy: true,
                    Cell: ({ row }) => {
                        const { id, attendance } = row.original;

                        const isPresent = attendance === "Present";
                        const isAbsent = attendance === "Absent";

                        return (
                            <div className="attendance-toggle">
                                <button
                                    className={isPresent ? "active present" : ""}
                                    onClick={() => updateTraineeAttendance(id, "Present")}
                                >
                                    <i className="fa fa-check" />
                                    Present
                                </button>

                                <button
                                    className={isAbsent ? "active absent" : ""}
                                    onClick={() => updateTraineeAttendance(id, "Absent")}
                                >
                                    <i className="fa fa-times" />
                                    Absent
                                </button>
                            </div>
                        );
                    },
                },
            ];

    const handleInputChange = (field, value) => {
        setFormData((prev) => {
            const updated = {
                ...prev,
                [field]: {
                    ...prev[field],
                    value,
                    error: "",
                    isChanged: true,
                },
            };

            if (field === "sessionStartTime") {
                updated.sessionEndTime = {
                    ...updated.sessionEndTime,
                    error: "",
                };
            }

            if (field === "sessionEndTime") {
                updated.sessionStartTime = {
                    ...updated.sessionStartTime,
                    error: "",
                };
            }

            return updated;
        });
    };

    const getValidationError = (name, value, currentFormData = formData) => {
        switch (name) {
            case "sessionDate":
                if (!value) {
                    return "Please select session date";
                }

                const selectedDate = value;
                selectedDate.setHours(0, 0, 0, 0);

                const today = new Date();
                today.setHours(0, 0, 0, 0);

                const maxDate = new Date(today);
                maxDate.setMonth(maxDate.getMonth() + 1);

                if (selectedDate > maxDate) {
                    return "Session date cannot be more than 1 month from today";
                }

                return "";

            case "sessionStartTime":
                if (!value) {
                    return "Please select session start time";
                }

                if (currentFormData.sessionEndTime.value) {
                    const start = new Date(`2000-01-01T${value}`);
                    const end = new Date(
                        `2000-01-01T${currentFormData.sessionEndTime.value}`,
                    );

                    if (start >= end) {
                        return "Start time must be before end time";
                    }

                    if (end - start < 30 * 60 * 1000) {
                        return "Start and end time must have at least 30 minutes difference";
                    }
                }

                return "";

            case "sessionEndTime":
                if (!value) {
                    return "Please select session end time";
                }

                if (currentFormData.sessionStartTime.value) {
                    const start = new Date(
                        `2000-01-01T${currentFormData.sessionStartTime.value}`,
                    );
                    const end = new Date(`2000-01-01T${value}`);

                    if (end <= start) {
                        return "End time must be after start time";
                    }

                    if (end - start < 30 * 60 * 1000) {
                        return "Session duration must be at least 30 minutes";
                    }
                }

                return "";

            case "sessionType":
                return !value ? "Please select session type" : "";

            case "sessionStatus":
                return !value ? "Please select lesson status" : "";

            default:
                return "";
        }
    };



    const handleOnBlur = (name, value) => {
        const trimmedValue = typeof value === "string" ? value.trim() : value;

        setFormData((prev) => {
            const updated = {
                ...prev,
                [name]: {
                    ...prev[name],
                    value: trimmedValue,
                },
            };

            updated[name].error = getValidationError(name, trimmedValue, updated);

            return updated;
        });
    };

    const buildFilterParams = () => {
        const filterParams = [];

        if (searchState.searchName?.trim()) {
            filterParams.push({
                field: "TraineeName",
                condition: "like",
                filterValues: [searchState.searchName.trim()],
            });
        }

        if (searchState.searchEmail?.trim()) {
            filterParams.push({
                field: "Email",
                condition: "like",
                filterValues: [searchState.searchEmail.trim()],
            });
        }

        return filterParams?.length > 0 ? JSON.stringify(filterParams) : [];
    };

    const handleSearch = () => {
        const newFilterParams = buildFilterParams();

        if (
            JSON.stringify(searchState.filterParams) !==
            JSON.stringify(newFilterParams)
        ) {
            setAlternative((prev) => ({
                ...prev,
                isLoading: true,
                showLoaderOnSearch: true,
            }));

            setSearchState((prev) => ({
                ...prev,
                filterParams: newFilterParams,
            }));

            if (pageNum !== 1) {
                setPageNum(1);
            }
        }
    };

    const handleClear = () => {
        setAlternative((prev) => ({
            ...prev,
            isLoading: false,
            showLoaderOnSearch: false,

        }));

        setSearchState({
            searchName: "",
            searchEmail: "",
            searchMobile: "",
            filterParams: [],
        });

        if (pageNum !== 1) {
            setPageNum(1);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            handleSearch();
        }
    };

    const markSelectedPresent = () => {
        setAttendanceMap(prev => {
            const updated = { ...prev };

            selectedRows.forEach(id => {
                updated[id] = "Present";
            });

            return updated;
        });

        setTrainees(prev =>
            prev.map(t =>
                selectedRows.includes(t.id)
                    ? { ...t, attendance: "Present" }
                    : t
            )
        );

        setSelectedRows([]);
    };

    const markSelectedAbsent = () => {
        setAttendanceMap(prev => {
            const updated = { ...prev };

            selectedRows.forEach(id => {
                updated[id] = "Absent";
            });

            return updated;
        });

        setTrainees(prev =>
            prev.map(t =>
                selectedRows.includes(t.id)
                    ? { ...t, attendance: "Absent" }
                    : t
            )
        );

        setSelectedRows([]);
    };

    const updateTraineeAttendance = (id, status) => {
        setAttendanceMap(prev => ({
            ...prev,
            [id]: status,
        }));

        setTrainees(prev =>
            prev.map(t =>
                t.id === id
                    ? { ...t, attendance: status }
                    : t
            )
        );
    };

    const handleClose = () => {
        setFormData(initialFormData);
        setSearchState({
            searchName: "",
            searchEmail: "",
            searchMobile: "",
            filterParams: [],
        });
        setSelectedRows([]);
        setPageNum(1);
        setAttendanceMap({});
        setTrainees([]);
        setAlternative({
            isLoading: true,
            showLoaderOnClick: false,
            showLoaderOnSearch: false,
            error: "",
            noRecords: false,
        });
        setTraineesRecords({ totalRecords: null, totalFilteredRecords: null });
        props.handleCloseModel()
    }

    const validateForm = () => {
        let newSession = { ...formData };

        //get all the keys in array
        Object.keys(newSession).forEach((key) => {
            newSession[key] = {
                ...newSession[key],
                error: getValidationError(key, newSession[key].value, newSession),
            };
        });
        setFormData(newSession); //if error set error state
        return Object.values(newSession).every((item) => item.error === "");
    };

    const handleSave = async () => {
        if (!validateForm()) return;

        try {
            setAlternative((prev) => ({ ...prev, showLoaderOnClick: true }));

            const bodyData =
            {
                batchId: formData.batchId.value,
                sessionDate: format(formData.sessionDate.value, "yyyy-MM-dd"),
                sessionStartTime: formData.sessionStartTime.value.substring(0, 5),
                sessionEndTime: formData.sessionEndTime.value.substring(0, 5),
                sessionType: formData.sessionType?.value?.value,
                sessionStatus: formData.sessionStatus?.value?.value,
                // Convert attendance map into the API-required array format.
                traineeAttendance: Object.entries(attendanceMap).map(
                    ([traineeId, status]) => ({
                        traineeId: Number(traineeId), // Convert object key to number
                        status: status.toUpperCase(),  // Convert to API enum: PRESENT / ABSENT
                    })
                ),
            };

            let res;

            if (props?.mode === "Edit") {
                res = await updateAttendance(props.session.id, bodyData);
            } else if (props?.mode === "Add") {
                res = await addAttendance(bodyData);
            }

            if (res?.code === 200) {
                notify("success", res?.message || (props.mode === "Edit"
                    ? "Attendance updated successfully."
                    : "Attendance added successfully.")
                );
                setTimeout(() => {
                    props.onSaveAttendace(props?.course?.id, props?.batch?.id);
                    handleClose();
                }, 500);
            } else {
                const message = Array.isArray(res?.message)
                    ? res.message
                        .map((err) => (err?.Msg ? err.Msg : JSON.stringify(err)))
                        .join(", ")
                    : res?.message || (props.mode === "Edit"
                        ? "Failed to update attendance."
                        : "Failed to add attendance.");
                notify("danger", message);
            }

        } catch (e) {
            notify("danger", "Something went wrong");
        } finally {
            setAlternative((prev) => ({ ...prev, showLoaderOnClick: false }));
        }
    };


    return (
        <RightPanelCard
            isOpen={props.openAttendaceModel}
            onClose={handleClose}
            fullHeight
            enableScroll={true}
        >
            <Card className="attendance-card shadow-none border-0">
                <CardHeader>
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                            <h4 className="mb-0 text-default">{props?.mode === "View"
                                ? "Attendance Details"
                                : `${props?.mode} Attendance`}</h4>
                        </div>

                        <i
                            className="fa-solid fa-xmark cursor text-muted"
                            onClick={() => handleClose()}
                        />
                    </div>
                </CardHeader>
                <CardBody className="attendance-card-body">
                    {/* <div className="context-description">
                        <i className="fa fa-info-circle mr-2" />
                        Add a session and mark trainee attendance for the selected lesson.
                    </div>

                    <div className="session-context">
                        <div className="context-item">
                            <span className="context-label">Lesson</span>
                            <h4>{props.panelData?.lesson?.name}</h4>
                        </div>
                    </div>
                    <hr className="divider" /> */}
                    {props?.mode === "View" ? (
                        <>
                            <h4 className={`mb-0 text-default mb-3`}>Session Details</h4>
                            <div className="session-summary">
                                <div className="summary-item">
                                    <Label className="small-label text-muted mb-0">Session Date</Label>
                                    <p className="small-text text-wrapper">{formData.sessionDate.value
                                        ? format(formData.sessionDate.value, "dd MMM yyyy")
                                        : "-"}
                                    </p>
                                </div>

                                <div className="summary-item">
                                    <Label className="small-label text-muted mb-0">Session Time</Label>
                                    <p className="small-text text-wrapper">
                                        {formData.sessionStartTime.value} - {formData.sessionEndTime.value}
                                    </p>
                                </div>

                                <div className="summary-item">
                                    <Label className="small-label text-muted mb-0">Session Type</Label>
                                    <p className="small-text text-wrapper">{formData.sessionType.value?.label}</p>
                                </div>

                                {/*<div className="summary-item">
                                    <Label className="small-label text-muted mb-0">Status</Label>
                                    <p className="small-text text-wrapper">{formData.sessionStatus.value?.label}</p>
                                </div>*/}
                            </div>
                        </>
                    ) : <div>
                        <Label className="form-control-label mb-3">
                            Note: Some dates are unavailable because attendance is already marked or the date is in the future. Please select an available date.
                        </Label>
                        <div className="divider mt-0 mb-4" />
                        <Row>
                            <Col md="6" sm="12">
                                <FormGroup>
                                    <Label className="form-control-label">
                                        Session Date
                                    </Label>
                                    <span className="text-danger"> *</span>
                                    <DatePicker
                                        selected={formData.sessionDate.value}
                                        onChange={(date) =>
                                            handleInputChange("sessionDate", date)
                                        }
                                        onBlur={() => handleOnBlur("sessionDate", formData.sessionDate.value)}
                                        dateFormat="dd-MMM-yyyy"
                                        placeholderText="Select session date"
                                        openToDate={firstAvailableDate}
                                        showMonthDropdown
                                        showYearDropdown
                                        scrollableYearDropdown
                                        yearDropdownItemNumber={100}

                                        showIcon
                                        icon={
                                            <i className="fa-solid fa-calendar-day fa-md mt-1 mr-4 text-muted" />
                                        }
                                        toggleCalendarOnIconClick
                                        className={`form-control ${formData.sessionDate.error ? "is-invalid" : ""
                                            }`}
                                        wrapperClassName="w-100"
                                        calendarClassName="custom-calendar"
                                        popperPlacement="bottom-start"
                                        onKeyDown={(e) => e.preventDefault()}
                                        onPaste={(e) => e.preventDefault()}
                                        minDate={minAvailableDate}
                                        // maxDate={maxAvailableDate}
                                        maxDate={new Date()}
                                        filterDate={(date) =>
                                            availableSessionDates.some(
                                                (availableDate) =>
                                                    format(date, "yyyy-MM-dd") === availableDate
                                            )
                                        }
                                        disabled={props?.mode === "Edit"}
                                    />
                                    {formData.sessionDate.error && (
                                        <div className="invalid-feedback d-block">
                                            {formData.sessionDate.error}
                                        </div>
                                    )}
                                </FormGroup>
                            </Col>
                            <Col md="6" sm="12">
                                <FormGroup>
                                    <Label className="form-control-label">
                                        Session Type <span className="text-danger">*</span>
                                    </Label>
                                    <Select
                                        placeholder="Select session type"
                                        options={props?.mode === "Edit" || props?.mode === "View" ? ALL_SESSION_TYPE_OPTIONS : sessionTypeOptions}
                                        styles={SELECT_CUSTOM_STYLES}
                                        value={formData.sessionType.value}
                                        // value={
                                        //     formData.sessionType.value
                                        //         ? SESSION_TYPE_OPTIONS.find(
                                        //             (opt) => opt.value === formData.sessionType.value,
                                        //         )
                                        //         : null
                                        // }
                                        onChange={(selected) =>
                                            handleInputChange("sessionType", selected)
                                        }
                                        className={formData.sessionType.error ? "is-invalid" : ""}
                                        onBlur={() => handleOnBlur("sessionType", formData.sessionType.value)}
                                    />
                                    {formData.sessionType.error && (
                                        <small className="invalid-feedback d-block">
                                            {formData.sessionType.error}
                                        </small>
                                    )}
                                </FormGroup>
                            </Col>
                            <Col md="3" sm="12">
                                <FormGroup>
                                    <Label className="form-control-label">
                                        Start Time<span className="text-danger"> *</span>
                                    </Label>
                                    <CustomTimePicker
                                        value={parseTimeStringToDate(formData.sessionStartTime.value)}
                                        onChange={(date) =>
                                            handleInputChange("sessionStartTime", date ? format(date, "HH:mm") : "")
                                        }
                                        className={`form-control ${formData.sessionStartTime.error
                                            ? "is-invalid"
                                            : ""
                                            }`}
                                        placeholder="Select start time"
                                        onBlur={() => handleOnBlur("sessionStartTime", formData.sessionStartTime.value)}
                                    />
                                    {formData.sessionStartTime.error && (
                                        <small className="invalid-feedback d-block">
                                            {formData.sessionStartTime.error}
                                        </small>
                                    )}
                                </FormGroup>
                            </Col>
                            <Col md="3" sm="12">
                                <FormGroup>
                                    <Label className="form-control-label">
                                        End Time<span className="text-danger"> *</span>
                                    </Label>
                                    <CustomTimePicker
                                        value={parseTimeStringToDate(formData.sessionEndTime.value)}
                                        minTime={parseTimeStringToDate(addMinutes(formData.sessionStartTime.value, 30))}
                                        maxTime={parseTimeStringToDate("23:59")}
                                        onChange={(date) =>
                                            handleInputChange("sessionEndTime", date ? format(date, "HH:mm") : "")
                                        }
                                        className={`form-control ${formData.sessionEndTime.error
                                            ? "is-invalid"
                                            : ""
                                            }`}
                                        placeholder="Select end time"
                                        onBlur={() => handleOnBlur("sessionEndTime", formData.sessionEndTime.value)}
                                    />
                                    {formData.sessionEndTime.error && (
                                        <small className="invalid-feedback d-block">
                                            {formData.sessionEndTime.error}
                                        </small>
                                    )}
                                </FormGroup>
                            </Col>

                            <Col md="6" sm="12">
                                <FormGroup>
                                    <Label className="form-control-label">
                                        {/* Previously it was Lesson Status but later replaced with Batch Status */}
                                        Batch Status <span className="text-danger">*</span>
                                    </Label>
                                    <i className="fa fa-circle-info ml-2 cursor" id="lessonStatusInfo" />
                                    <UncontrolledTooltip
                                        target="lessonStatusInfo"
                                        placement="right"
                                        delay={0}
                                        innerClassName="custom-tooltip"
                                    >
                                        Select <strong>Completed</strong> only when the batch training is
                                        completed. Otherwise, keep the batch status as{" "}
                                        <strong>Ongoing</strong>.
                                    </UncontrolledTooltip>
                                    <Select
                                        placeholder="Select batch status"
                                        options={SESSION_STATUS_OPTIONS}
                                        styles={SELECT_CUSTOM_STYLES}
                                        value={formData.sessionStatus.value}
                                        onChange={(selected) =>
                                            handleInputChange("sessionStatus", selected)
                                        }
                                        className={formData.sessionStatus.error ? "is-invalid" : ""}
                                        onBlur={() => handleOnBlur("sessionStatus", formData.sessionStatus.value)}
                                    />
                                    {formData.sessionStatus.error && (
                                        <small className="invalid-feedback d-block">
                                            {formData.sessionStatus.error}
                                        </small>
                                    )}
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>}
                    <div className="divider mt-2 mb-4" />
                    <h4 className={`mb-0 text-default ${props?.mode === "View" ? "mb-4" : ""}`}>Trainee List</h4>
                    {props?.mode === "Add" && <div className="attendance-info mt-2">
                        <i className="fa fa-circle-info" />
                        <span>
                            All trainees are marked <strong>Present</strong> by default.
                            Select one or more trainees to update their attendance if required.
                        </span>
                    </div>}
                    <div className="d-flex align-items-center justify-content-between flex-wrap flex-column flex-md-row mt-3 mb-0">
                        <div className="d-flex flex-wrap align-items-center filter-group">
                            <Input
                                type="text"
                                placeholder="Search by name"
                                className="mr-2 mb-2 filter-input-large"
                                value={searchState.searchName}
                                onChange={(e) =>
                                    setSearchState((prev) => ({
                                        ...prev,
                                        searchName: e.target.value,
                                    }))
                                }
                                onKeyDown={handleKeyDown}
                            />
                            <Input
                                type="text"
                                placeholder="Search by email"
                                className="mr-2 mb-2 filter-input-large"
                                value={searchState.searchEmail}
                                onChange={(e) =>
                                    setSearchState((prev) => ({
                                        ...prev,
                                        searchEmail: e.target.value,
                                    }))
                                }
                                onKeyDown={handleKeyDown}
                            />
                            <Button
                                color="default"
                                className={`d-flex align-items-center mb-2 filter-btn btn-deep-blue ${alternative.showLoaderOnSearch ? "search-btn" : ""}`}
                                onClick={handleSearch}
                            >
                                {alternative.showLoaderOnSearch ? (
                                    <i className="fa fa-spinner fa-spin loader" />
                                ) : (
                                    <>
                                        <i className="fa fa-search mr-1" />
                                        Search
                                    </>
                                )}
                            </Button>

                            {searchState?.filterParams?.length > 0 && (
                                <Button
                                    color="default"
                                    className="d-flex align-items-start mb-2 ml-0 filter-btn btn-deep-blue px-4"
                                    onClick={handleClear}
                                >
                                    <i className="fa fa-times mr-1 mt-1" /> Clear
                                </Button>
                            )}
                        </div>
                    </div>
                    {props.mode !== "View" &&
                        <>
                            <div className="attendance-toolbar">
                                <div>
                                    <span className="selected-count">
                                        Selected trainees: {selectedRows?.length}
                                    </span>
                                </div>

                                <div className="attendance-actions">
                                    <Button
                                        color={!selectedRows?.length ? "secondary" : "success"}
                                        outline={selectedRows?.length ? true : false}
                                        className="mr-2 save-btn-lg"
                                        type="button"
                                        onClick={markSelectedPresent}
                                    >
                                        <i className="fa fa-check mr-2" />
                                        Mark Present
                                    </Button>

                                    <Button
                                        color={!selectedRows?.length ? "secondary" : "warning"}
                                        outline={selectedRows?.length ? true : false}
                                        className="mr-2 save-btn-lg"
                                        type="button"
                                        onClick={markSelectedAbsent}
                                    >
                                        <i className="fa fa-times mr-2" />
                                        Mark Absent
                                    </Button>
                                </div>
                            </div>
                        </>
                    }

                    {alternative.isLoading ? (<div className="attendanceContainer">
                        <i className="fa fa-spinner fa-spin fa-2xl loader" />
                    </div>) : alternative.error ? (
                        <div className="attendanceContainer error-style">
                            <div className="error-icon">
                                <i className="fa-solid fa-circle-exclamation" />
                            </div>
                            <span>{alternative.error}</span>
                        </div>
                    ) : alternative.noRecords ? (
                        <div className="attendanceContainer empty-style">
                            <div className="empty-icon">
                                <i className="fa-solid fa-circle-info" />
                            </div>
                            <span>No enrolled trainee found.</span>
                        </div>
                    ) : <div className="table-responsive">
                        <CommonTable
                            columns={columns}
                            data={traineeTableData}
                            defaultPageSize={DEFAULT_RECORDS_PER_PAGE}
                            activePage={pageNum}
                            setPageNum={setPageNum}
                            // totalPages={Math.ceil(
                            //     (courseEnrollmentData?.data?.totalFilteredRecords || traineeTableData?.length) /
                            //     (courseEnrollmentData?.data?.noOfRecordsPerPage || DEFAULT_RECORDS_PER_PAGE),
                            // )}

                            totalPages={
                                props.mode === "Add"
                                    ? Math.ceil(
                                        (courseEnrollmentData?.data?.totalFilteredRecords || 0) /
                                        (courseEnrollmentData?.data?.noOfRecordsPerPage ||
                                            DEFAULT_RECORDS_PER_PAGE)
                                    )
                                    : Math.ceil(
                                        traineesRecords?.totalRecords / DEFAULT_RECORDS_PER_PAGE
                                    )
                            }

                            showPaginationBottom={true}
                        />
                    </div>}
                </CardBody>
                <CardFooter className="attendance-footer">
                    <Button
                        color="secondary"
                        className="mr-2 save-btn-sm"
                        type="button"
                        onClick={handleClose}
                        disabled={alternative.showLoaderOnClick}
                    >
                        {props?.mode === "View" ? "Close" : "Cancel"}
                    </Button>

                    {props.mode !== "View" && <Button
                        color="primary"
                        className="btn-deep-blue mr-2 save-btn-sm"
                        type="button"
                        onClick={handleSave}
                        disabled={alternative.showLoaderOnClick || Object.values(formData).some(
                            (item) => item.error !== "",
                        )}
                    >
                        {alternative.showLoaderOnClick ? (
                            <i className="fa fa-spinner fa-spin fa-lg text-white" />
                        ) : (
                            "Save"
                        )}
                    </Button>}
                </CardFooter>
            </Card>

        </RightPanelCard>
    )
}

export default ManageOfflineAttendance
